import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df03927e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0 5px"} }, "版权所有", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 备案号：")
const _hoisted_4 = {
  href: "https://beian.miit.gov.cn",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("span", null, _toDisplayString(_ctx.conmpanyName), 1),
      _hoisted_2,
      _createElementVNode("span", null, [
        _hoisted_3,
        _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.recordNumber), 1)
      ])
    ])
  ]))
}